import { PlusIcon } from '@heroicons/react/solid';

import { Button, Card, CardSection, Text } from '@/lib/v2/components';

type CTACardSmallProps = {
  icon: JSX.Element;
  description: string;
  buttonText: string;
  linkText: string;
  linkUrl?: string;
  onClickButton?: () => void;
  className?: string;
};

const CTACardSmall = ({
  icon,
  description,
  buttonText,
  linkText,
  linkUrl,
  onClickButton,
  className,
}: CTACardSmallProps) => {
  return (
    <Card className={className}>
      <CardSection>
        <div className="flex flex-col gap-4">
          {icon}
          <Text variant="text">{description}</Text>
          <Button
            outline
            secondary
            standard
            iconLeft={<PlusIcon className="size-5" />}
            onClick={onClickButton}
          >
            {buttonText}
          </Button>
          <Text link color="primary" href={linkUrl} target="_blank" variant="text-sm">
            {linkText}
          </Text>
        </div>
      </CardSection>
    </Card>
  );
};

export default CTACardSmall;
